import useModal from 'components/ui/ModalContainer/useModal';
import {useLanguage} from 'context/language-context';

const useRestrictedActivitiesModal = () => {
    const {selectedLanguageParams} = useLanguage();
    const {closeModal} = useModal();

    return {
        closeModal,
        selectedLanguageParams,
    };
};

export default useRestrictedActivitiesModal;
